import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b2dbd06a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2dbd06a')) {
      api.createRecord('b2dbd06a', component.options)
    } else {
      api.reload('b2dbd06a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b2dbd06a&", function () {
      api.rerender('b2dbd06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DmE6mNkGyxYF/JS/imageCarousel.vue"
export default component.exports